/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { V2PaymentRequest, V2PaymentResponse } from '@api';
import { Create, Request } from 'src/js/common/epics/EpicUtils';
import { CHECKOUT_COMPLETE_WINDCAVE_CC_PAYMENT } from 'src/js/enrol/containers/payment/actions/Actions';
import CheckoutApiService from 'src/js/enrol/services/CheckoutApiService';
import CheckoutService from 'src/js/enrol/services/CheckoutService';

const request: Request<V2PaymentResponse, { paymentSessionId: string }> = {
  type: CHECKOUT_COMPLETE_WINDCAVE_CC_PAYMENT,
  getData: ({ paymentSessionId }, state) => {
    const paymentRequest: V2PaymentRequest = {
      onCourseSessionId: paymentSessionId,
      merchantReference: state.checkout.payment.merchantReference
    };
    return CheckoutApiService.submitCreditCardPayment(
      paymentRequest,
      state.checkout.payerId
    )
  },
  processData: (response: V2PaymentResponse) => CheckoutService.processPaymentResponse(response),
  processError: CheckoutService.prcessPaymentError
};

export const EpicCompleteWindcavePayment = Create(request);